import { loginByPassword, logout } from '@/api/common/login';
import { sendCertificateNumber, getUserDashboard, userPauseUnlock } from '@/api/common/user';
import { getTermsPopupList } from '@/api/main/main';
import { searchBizPoint } from '@/api/common/mybiz';
import { getLevelCodeList } from '@/api/ggoods/estimate';
import sessionStore from '@/utils/sessionStore';
import alarmMsg from '@/utils/alarmMsg';
import router from '@/router';
import _, { isNil } from 'lodash';
import tokenStore from '@/utils/TokenManager/tokenStore';
import ChannelService from '@/lib/channel';
import { crmLogin } from '@/helpers/ad/crm/crm.js';
import { checkTokenValidation, panchokUserLogout } from '@/api/panchok/auth';
import moment from 'moment';
import { getPaymentsBlockInfo } from '@/api/common/user';
import { getContactTagListAll } from '@/api/contactMng/contactMng';

export default {
	state: {
		token: undefined,
		decodedAccessToken: undefined,
		refreshToken: undefined,
		decodedRefreshToken: undefined,
		userInfo: {},
		registName: '',
		registPhoneNumber: '',
		certificateNumber: '',
		lastRequestTime: Date.now(),
		bizMoney: '',
		channelBadgeCnt: 0,
		termsList: [],
		gradeList: null,
		allowPayMethods: [], // 허용된 결제수단
		blockedPayMethods: [], // 제한된 결제수단
		contactTagList: [], // 연락처 태그 리스트.
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token;
			state.decodedAccessToken = tokenStore.getDecodedToken().accessToken;
		},
		SET_REFRESH_TOKEN: (state, refreshToken) => {
			state.refreshToken = refreshToken;
			state.decodedRefreshToken = tokenStore.getDecodedToken().refreshToken;
		},
		SET_USER_INFO: (state, userInfo) => {
			state.userInfo = userInfo;
		},
		SET_REGIST_NAME: (state, registName) => {
			state.registName = registName;
		},
		SET_REGIST_PHONE_NUMBER: (state, registPhoneNumber) => {
			state.registPhoneNumber = registPhoneNumber;
		},
		SET_REGIST_CERTIFICATENUMBER: (state, certificateNumber) => {
			state.certificateNumber = certificateNumber;
		},
		SET_LAST_REQUEST_TIME: (state, time) => {
			state.lastRequestTime = time;
		},
		SET_BIZ_MONEY: (state, bizMoney) => {
			state.bizMoney = bizMoney;
		},
		SET_CHANNEL_BADGE_CNT: (state, channelBadgeCnt) => {
			state.channelBadgeCnt = channelBadgeCnt;
		},
		SET_TERMS_POPUP_LIST: (state, termsList) => {
			state.termsList = termsList;
		},
		SET_GRADE_INFO: (state, grade) => {
			state.gradeList = grade;
		},
		SET_USER_PAY_METHODS(state, { allowPayMethods, blockedPayMethods }) {
			// state.allowPayMethods = []
			state.allowPayMethods = allowPayMethods;
			state.blockedPayMethods = blockedPayMethods;
		},

		SET_USER_CONTACT_TAG_LIST(state, tags) {
			state.contactTagList = tags;
		},
	},

	actions: {
		async LoginByPassword({ commit, state, dispatch }, { userId, userPassword, beforeData }) {
			const response = await loginByPassword(userId, userPassword);

			if (response.code === 'ERR0140') {
				// 비정상 접근 시도
				const msg = '비정상적인 경로로 접근하였습니다. 다시 이용해주세요.';
				alarmMsg.showMsg(msg).then(() => {
					router.push({ name: 'home' });
				});
			}

			// 3개월 비밀번호 변경
			if (response.code === 'ERR0129') {
				sessionStore.set('chgPwdToken', response.message);
				sessionStore.set('chgPwdUserId', userId);
				router.push({ name: 'changepwd' });
				return;
			}

			// 서브회원 id 로그인
			if (response.code === 'ERR0132') {
				sessionStore.set('submember', response.code);
				sessionStore.set('subtoken', response.message);
				alarmMsg
					.showMsg(
						'본인 인증을 하지 않은 회원은 최초 로그인 시 1회 본인 인증을 진행합니다. <br/>임시비밀번호로 로그인 하신 경우 비밀번호를 재설정해주세요.'
					)
					.then(confirm => {
						router.push({ name: 'smsCertification' });
					});
				return;
			}

			// 휴면계정
			if (response.code === 'ERR0123' || response.code === 'ERR0120') {
				const [period, message] = response.message.split('|');

				alarmMsg
					.showConfirm(
						`회원님의 계정으로 ${
							message ? period : '1'
						}년 이상 로그인하지 않아 현재 휴면 상태입니다.<br>휴면 계정을 해지하고 다시 이용하시겠습니까?`,
						'안내'
					)
					.then(() => {
						userPauseUnlock({
							userId,
						})
							.then(res => {
								if (res.code === 'SUC0000') {
									alarmMsg
										.showMsg(
											'휴면 계정이 해지되었습니다. <br>로그인 후 기프티쇼 비즈 서비스를 정상적으로 이용하실 수 있습니다.'
										)
										.then(confirm => {
											router.push('/login');
										});
								} else {
									alarmMsg.getMsg(res);
								}
							})
							.catch(reject => {
								alarmMsg.getMsg(res);
							});
					});
				return;
			}

			if (response.code !== 'SUC0000') {
				sessionStorage.setItem('loginAlarm', response.code);
				alarmMsg.getMsg(response);
				return;
			}

			tokenStore.set({
				accessToken: response.result.accessToken,
				refreshToken: response.result.refreshToken,
			});

			// 로그인 버튼 입력 이벤트 후처리 위해, 임시 세션스토리지에 저장
			sessionStore.set('actionLogin', 'Y');

			await dispatch('updateUserInfo');

			await dispatch('getTermsPopupList');

			// panchok
			await dispatch('checkPanchokToken', response.result.refreshToken);

			const bizMoneyResponse = await searchBizPoint({});

			if (bizMoneyResponse.code !== 'SUC0000') throw new Error(`${bizMoneyResponse.code}: ${bizMoneyResponse.message}`);

			/** crm login */
			crmLogin(
				{ ...state.userInfo, userNo: `${state.decodedRefreshToken?.userNo}` },
				bizMoneyResponse.result.pointValue
			);

			// 전환스크립트
			try {
				sessionStorage.setItem('email', userId);
				window.adsLogin(userId);
				window.gtag('event', 'login', { send_to: 'AW-859627067' });
			} catch (e) {
				console.error('Error during external Ads interact script');
			}

			if (beforeData?.name || beforeData?.path) {
				router.replace({
					...beforeData,
					params: {
						...beforeData.params,
						isDialogOpen: true,
					},
				});
				return;
			}
			if (response?.result?.bizShopYn === 'Y') {
				location.replace('/bizshop');
				return;
			}

			// location.replace('/');
			router.replace({
				name: 'home',
				params: {
					isDialogOpen: true,
				},
			});
		},
		async autoLogin({ commit, state, dispatch }, payload) {
			const response = payload;

			//console.log('autoLogin :', response);
			//return;

			// 3개월 비밀번호 변경
			if (response.code === 'ERR0129') {
				sessionStore.set('chgPwdToken', response.message);
				sessionStore.set('chgPwdUserId', response.result.userId);
				router.push({ name: 'changepwd' });
				return;
			}

			// 서브회원 id 로그인
			if (response.code === 'ERR0132') {
				sessionStore.set('submember', response.code);
				sessionStore.set('subtoken', response.message);
				alarmMsg
					.showMsg(
						'본인 인증을 하지 않은 회원은 최초 로그인 시 1회 본인 인증을 진행합니다.<br/>임시비밀번호로 로그인 하신 경우 비밀번호를 재설정해주세요.'
					)
					.then(() => {
						router.push({ name: 'smsCertification' });
					});
				return;
			}

			// 휴면계정
			if (response.code === 'ERR0123' || response.code === 'ERR0120') {
				const [period, message] = response.message.split('|');

				alarmMsg
					.showConfirm(
						`회원님의 계정으로 ${
							message ? period : '1'
						}년 이상 로그인하지 않아 현재 휴면 상태입니다.<br>휴면 계정을 해지하고 다시 이용하시겠습니까?`,
						'안내'
					)
					.then(() => {
						userPauseUnlock({
							userId: response.result.userId,
						})
							.then(res => {
								if (res.code === 'SUC0000') {
									alarmMsg
										.showMsg(
											'휴면 계정이 해지되었습니다. <br>로그인 후 기프티쇼 비즈 서비스를 정상적으로 이용하실 수 있습니다.'
										)
										.then(() => {
											router.push('/login');
										});
								} else {
									alarmMsg.getMsg(res);
								}
							})
							.catch(reject => {
								alarmMsg.getMsg(reject.code);
							});
					});
				return;
			}

			if (response.code !== 'SUC0000') {
				alarmMsg.getMsg(response);
				return;
			}

			tokenStore.set({
				accessToken: response.result.accessToken,
				refreshToken: response.result.refreshToken,
			});

			await dispatch('updateUserInfo');

			await dispatch('checkPanchokToken', response.result.refreshToken);

			const bizMoneyResponse = await searchBizPoint({});

			if (bizMoneyResponse.code !== 'SUC0000') throw new Error(`${bizMoneyResponse.code}: ${bizMoneyResponse.message}`);

			/** crm login */
			crmLogin(
				{ ...state.userInfo, userNo: `${state.decodedRefreshToken?.userNo}` },
				bizMoneyResponse.result.pointValue
			);

			// 전환스크립트
			try {
				sessionStorage.setItem('email', response.result.userId);
				window.adsLogin(response.result.userId);
				window.gtag('event', 'login', { send_to: 'AW-859627067' });
			} catch (e) {
				console.error('Error during external Ads interact script');
			}

			// 로그인 버튼 입력 이벤트 후처리 위해, 임시 세션스토리지에 저장
			sessionStore.set('actionLogin', 'Y');

			/*if (response?.result?.bizShopYn === 'Y') {
        location.replace('/bizshop');
        return;
      }*/

			location.replace('/home');
		},
		autoLogin2(context, payload) {
			const { code, result, message } = payload;
			if (code === 'SUC0000') {
				// login 결과 받아온 User Information을 store에 저장한다.
				// sessionStrage에 토큰값 저장, 토큰값이 따로 없을 경우, userId로 처리
				let tokenDate = moment().format('YYYY-MM-DD HH:mm:ss');
				sessionStore.set('accessToken', result.accessToken);
				sessionStore.set('refreshToken', result.refreshToken);
				sessionStore.set('userNo', result.userNo + '');
				sessionStore.set('tokenDate', tokenDate);
				sessionStore.set('userId', result.userId);

				// 신한 카드 인증
				if (result.transNo) {
					sessionStore.set('transNo', result.transNo);
				}
				if (result.partnershipLevelCode) {
					sessionStore.set('partnershipLevelCode', result.partnershipLevelCode);
				}
				if (result.partnershipCode) {
					sessionStore.set('partnershipCode', result.partnershipCode);
				}
				if (result.partnershipStartDate) {
					sessionStore.set('partnershipStartDate', result.partnershipStartDate);
				}

				let loginInfo = {
					accessToken: result.accessToken,
					refreshToken: result.refreshToken,
					userNo: result.userNo,
					tokenDate: tokenDate,
				};
				setLoginInfo(loginInfo);

				// 전환스크립트
				try {
					window.gtag('event', 'login', { send_to: 'AW-859627067' });
				} catch (e) {
					console.error('Error during external Ads interact script');
				}

				// 로그인 버튼 입력 이벤트 후처리 위해, 임시 세션스토리지에 저장
				sessionStore.set('actionLogin', 'Y');

				// bizShopYn 로그인
				if (result.bizShopYn && result.bizShopYn === 'Y') {
					location.replace('/bizshop');
				} else {
					location.replace('/home');
				}
			} else if (code === 'ERR0129') {
				// 3개월 비밀번호 변경
				sessionStore.set('chgPwdToken', message);
				sessionStore.set('chgPwdUserId', result.userId);
				router.push('/ChangePwd');
			} else if (code === 'ERR0132') {
				// 서브회원 id 로그인
				sessionStore.set('submember', code);
				sessionStore.set('subtoken', message);
				alarmMsg
					.showMsg(
						'본인 인증을 하지 않은 회원은 최초 로그인 시 1회 본인 인증을 진행 합니다. <br />임시 비밀번호로 로그인 하신 경우 비밀번호를 재설정 해주세요.'
					)
					.then(() => {
						// sms 인증으로 변경
						router.push('/smsCertification');
					});
			} else if (code === 'ERR0123' || code === 'ERR0120') {
				let data = {
					userId: result.userId,
				};
				alarmMsg
					.showConfirm(
						'회원님의 계정으로 1년 이상 로그인하지 않아 현재 휴면 상태입니다.<br>휴면 계정을 해지하고 다시 이용하시겠습니까?',
						'안내'
					)
					.then(() => {
						userPauseUnlock(data)
							.then(res => {
								if (res.code === 'SUC0000') {
									alarmMsg
										.showMsg(
											'휴면 계정이 해지되었습니다. <br>로그인 후 기프티쇼 비즈 서비스를 정상적으로 이용하실 수 있습니다.'
										)
										.then(() => {
											router.push('/login');
										});
								} else {
									alarmMsg.getMsg(res);
								}
							})
							.catch(error => {
								console.error('[userPauseUnlock error]', error);
								alarmMsg.getMsg('휴면 계정을 해지 오류입니다. 관리자에게 문의해주세요.');
							});
					});
			} else if (code === 'BZS0004') {
				// 다른계정 로그인 시도시
				alarmMsg.getMsg('연동계정으로 인증 후 연동이 가능합니다.');
			} else if (code === 'BZS0005') {
				// 로그인 실패
				alarmMsg.getMsg('아이디 또는 패스워드가 틀립니다.');
			} else {
				alarmMsg.getMsg('연동오류 <br />잠시 후 다시 이용해 주세요.' + code);
			}
		},

		checkPanchokToken(state, item) {
			checkTokenValidation({ refreshToken: item });
		},
		Logout({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				logout().then(response => {
					panchokUserLogout();
					tokenStore.clear();
					ChannelService.clear();
					resolve();
					location.replace('/');
				});
			});
		},
		LogoutStay({ commit, dispatch }) {
			// 회원탈퇴시 현재 페이지 유지 로그아웃 처리
			return new Promise((resolve, reject) => {
				logout().then(response => {
					panchokUserLogout();
					tokenStore.clear();
					ChannelService.clear();
					resolve();
				});
			});
		},
		LogoutWithdraw({ commit }) {
			// 회원탈퇴시 페이지 유지 로그아웃 처리
			return new Promise((resolve, reject) => {
				panchokUserLogout();
				tokenStore.clear();
				ChannelService.clear();
				resolve();
				location.replace('/memberInfowithdrawalend');
			});
		},
		LogoutWithoutAPI({ commit }) {
			tokenStore.clear();
			ChannelService.clear();
			location.replace('/');
		},
		SendCertificateNumber({ commit }, certificateInfo) {
			return new Promise((resolve, reject) => {
				// 인증번호 발송 API를 호출한다.
				// 호출 성공시 해당 인증번호, 사용자 정보 를 state 영역에 담아놓는다.
				// 회원가입시 기본 고정값으로 셋팅하기 위함
				sendCertificateNumber(certificateInfo.name, certificateInfo.phoneNumber)
					.then(response => {
						commit('SET_REGIST_NAME', certificateInfo.name);
						commit('SET_REGIST_PHONE_NUMBER', certificateInfo.phoneNumber);
						commit('SET_REGIST_CERTIFICATENUMBER', response);
						resolve();
					})
					.catch(error => {
						// 호출 실패시 state 값 초기화
						commit('SET_REGIST_NAME', '');
						commit('SET_REGIST_PHONE_NUMBER', '');
						commit('SET_REGIST_CERTIFICATENUMBER', '');
						reject(error);
					});
			});
		},
		SetBizMoney({ commit }) {
			return new Promise((resolve, reject) => {
				searchBizPoint({})
					.then(response => {
						if (response.code === 'SUC0000') {
							commit('SET_BIZ_MONEY', response.result.pointValue);
							resolve(response);
						} else {
							reject(response);
						}
					})
					.catch(error => {
						console.error('[searchBizPoint]', error);
						reject(error);
					});
			});
		},

		async updateUserInfo({ commit, state, dispatch }) {
			if (!state.token) return;

			try {
				const response = await getUserDashboard({});

				if (response.code !== 'SUC0000') throw new Error(`${response.code}: ${response.message}`);
				if (response.result.laterSettlementAuth === 'Y') {
					alarmMsg.showMsg('후정산 계정은 PC에서만 이용가능합니다.').then(() => {
						dispatch('Logout');
					});
					return;
				}
				commit('SET_USER_INFO', response.result);
				// 채널톡 연동 정보 추가 요청 항목
				// profile = {
				//   totalOrderAmount : 총 구매금액,
				//   rmLimitGoods : rm 구매 제한 상품,
				//   rmLimitStatus : rm 회원 상태 제한,
				//   joinDate : 회원가입일,
				//   lastLoginDate : 최종 로그인 날짜,
				//   companyType : 사업자,
				//   bizMoney : 보유 비즈머니,
				//   foundDate : 창립기념일,
				//   limitPayMethod : 결제수단 제한,
				// }
				let profile = {};
				if (state.userInfo.profile) {
					profile = {
						...state.userInfo.profile,
						userTotalBuyAmount: state.userInfo.profile.totalOrderAmount,
					};
				}

				/** 채널 서비스에 사용자 정보 저장 */
				dispatch('fetchChannelService', {
					pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_KEY,
					customLauncherSelector: '#channel_service',
					hideChannelButtonOnBoot: true,
					memberId: state.decodedAccessToken.userId, // userId
					unsubscribeTexting: state.userInfo.smsAgreeYn !== 'Y', // 마케팅수신동의 SMS
					unsubscribeEmail: state.userInfo.mailingAgreeYn !== 'Y', // 마케팅수신동의 메일
					profile: {
						entry: window.location.host,
						userId: state.decodedAccessToken.userId, // userId
						email: state.userInfo.email, // 이메일
						name: state.userInfo.userName, // 이름
						mobileNumber: state.userInfo.mobileNo, // 핸드폰번호
						companyLevelCd: state.userInfo.companyLevelCd, // 회원등급
						masterYn: state.userInfo.masterYn, // 마스터/서브
						companyName: state.userInfo.companyName, // 상호명
						bizNo: state.userInfo.bizNo, // 사업자등록번호
						visitCnt: state.userInfo.visitCnt, // 로그인 횟수
						firstJoinDate: state.userInfo.firstJoinDate, // 가입일
						agreeReceiveMktSmsDate: state.userInfo.smsAgreeYn, // 마케팅수신동의(SMS)
						agreeReceiveMktEmailDate: state.userInfo.enabledMailingAgree, // 마케팅수신동의(Email)
						lastOrderDate: state.userInfo.lastOrderDate, // 마지막 거래일
						benefitAchieveStatus: state.userInfo.masterYn === 'Y' ? state.userInfo.benefitAchieveStatus : '미달성', // 혜택존
						totalBuyAmount: state.userInfo.totalBuyAmount,
						...profile, // 채널톡 연동 정보 추가 요청 항목
					},
				});
			} catch (error) {
				commit('SET_USER_INFO', {});
				console.error(error);
			}
		},

		async fetchChannelService({ commit }, payload = {}) {
			ChannelService.shutdown();

			// 시작 및 사용자 프로필 저장
			ChannelService.boot(payload, (error, user) => {
				if (error) {
					console.log(error);
					return;
				}
				commit('SET_CHANNEL_BADGE_CNT', user.alert);
			});

			// 뱃지 수 받아오기
			ChannelService.onBadgeChanged(unreadCount => {
				commit('SET_CHANNEL_BADGE_CNT', unreadCount);
			});
		},

		updateLastRequestTime({ commit }) {
			commit('SET_LAST_REQUEST_TIME', Date.now());
		},

		async getTermsPopupList({ commit, state }) {
			if (!state.token) return;

			try {
				const response = await getTermsPopupList({});

				if (response.code !== 'SUC0000') throw new Error(`${response.code}: ${response.message}`);

				commit('SET_TERMS_POPUP_LIST', response.result.termsPopupList);
			} catch (error) {
				commit('SET_TERMS_POPUP_LIST', {});
				console.error(error);
			}
		},
		async getGradeInfo({ commit, state }) {
			try {
				let userGrade = state.userInfo.companyLevelCd || 'GOLD';
				if (state.gradeList !== null && state.gradeList.find(({ LEVEL_CD }) => LEVEL_CD === userGrade)) return;
				const response = await getLevelCodeList({ requestLevelCodes: [userGrade] });
				if (response.code !== 'SUC0000') throw new Error(`${response.code}: ${response.message}`);
				commit('SET_GRADE_INFO', response.result.discountInfoList);
			} catch (error) {
				commit('SET_GRADE_INFO', null);
				console.error(error);
			}
		},

		// 결제수단제한조회
		async SetUserPayMethods({ commit }) {
			try {
				const { result, code, message } = await getPaymentsBlockInfo({});
				if (code !== 'SUC0000') {
					alarmMsg.showMsg(message);
					return false;
				}

				if (!result) {
					console.error('Not find result');
					return false;
				}

				commit('SET_USER_PAY_METHODS', result);
			} catch (e) {
				console.error('Error setting user:', e);
			}
		},

		// 연락처관리태그조회
		async SetUserContactTagList({ commit }, payload = {}) {
			try {
				const { result, code, message } = await getContactTagListAll(payload);

				if (code !== 'SUC0000') {
					alarmMsg.showMsg(message);
					return false;
				}

				if (!result) {
					console.error('Not find result');
					return false;
				}

				commit('SET_USER_CONTACT_TAG_LIST', result.tagList);
			} catch (e) {
				console.error('Error setting user:', e);
			}
		},
	},

	getters: {
		userNo: state => {
			// return getUserNo();
			return `${state.decodedRefreshToken?.userNo || ''}`;
		},
		userInfo: (state, getters) => ({
			...state.userInfo,
			userNo: getters.userNo,
		}),
		isMasterMember: state => state.userInfo?.masterYn === 'Y',
		isSubMember: state => state.userInfo?.masterYn === 'N',
		isLoggedIn: state => Boolean(state?.token),
		lastRequestTime: state => state.lastRequestTime,
		channelBadgeCnt: state => state.channelBadgeCnt,
		termsList: state => state.termsList,
		gradeList: state => state.gradeList,
		isSpecialGrade: state =>
			Boolean(state?.token) &&
			state.userInfo?.companyLevelCd !== 'GOLD' &&
			state.userInfo?.companyLevelCd !== 'VIP' &&
			state.userInfo?.companyLevelCd !== 'PLATINUM' &&
			state.userInfo?.companyLevelCd?.indexOf('ALPHA') === -1,
	},
};
